/**
 * ? @description : Grouped Teachers List and Ungrouping Teachers Method is written in this file.
 */

// Dependencies
import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import { useDispatch } from "react-redux";

// Ag-Grid CSS
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

// Modal Component
import UngroupedTeacher from "./teacher_modal/UngroupedTeacher";

// Axios Component
import Axios from "../../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../../redux/features/appSlice";
import axios from "axios";

function TeacherModal(props) {
  // * Redux Variables
  // console.log(props)
  const dispatch = useDispatch();
  //  const handleAttendanceModalClose = props.onCloseCallBack();

  // * State Variables
  const [selectedValue, setSelectedValue] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [getBatchId, setGetBatchId] = useState("");
  const [getBatchName, setGetBatchName] = useState("");
  const [addTeacher, setAddTeacher] = useState(false);
  // const [closedTable, setClosedTable]= useState('')
  // * Open Modal For Add Teachers
  const addTeachers = () => {
    setGetBatchId(props.datatomodal.batch_id);
    setGetBatchName(props.datatomodal.batch_name);
    setAddTeacher(true);
  };

  // * Columns Definition For Table Data
  const columnHeader = [
    {
      headerName: "Select",
      // field: "teacher_id",
      sortable: true,
      filter: true,
      checkboxSelection: true,
      headerCheckboxSelection: true,
    },
    {
      headerName: "Teacher Name",
      field: "teacher_name",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Languages",
      field: "teacherlanguages",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Group Name",
      field: "batch_name",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Group Id",
      field: "group_id",
      sortable: true,
      filter: true,
      hide: true
    },
    {
      headerName: "Group Status",
      field: "group_status",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Teacher Mapped Status",
      field: "teacher_mapped_status",
      sortable: true,
      filter: true,
      hide: true,
    },
    {
      headerName: "Mapped To Student",
      field: "mapped_to_student",
      sortable: true,
      filter: true,
      hide: true,
    },
    {
      headerName: "Teacher Status",
      field: "teacher_status",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Role",
      field: "role",
      sortable: true,
      filter: true,
    },
  ];

  // * Filter Data
  const onFilterTextChange = (e) => {
    filterData.setQuickFilter(e.target.value);
  };

  // ? API Call : Get Method : Grouped Teachers Data From Server
  const onGridReady = async (params) => {
    const controller = axios.CancelToken.source();

    try {
      setFilterData(params.api);

      const options = {
        method: "GET",
        url: `/batchview/teacherlist/batch/${props.datatomodal.batch_id}`,
        auth: true,
        data: null,
        token:{cancelToken: controller.token}
      };

      const response = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data,
        options.token,
        );

      params.api.applyTransaction({ add: response.data });
    } catch (error) {
      if (!axios.isCancel(error)) {
        dispatch(
          showSnackbar({
            message: "Error occurred! Unable to fetch data.",
            severity: "error",
          })
        );
      }

    }
    return () => {
      controller.cancel();
  }
  };

  // * Multiple Row Selection
  const rowSelectionType = "multiple";

  // * Passing Selected Rows to State Variable
  const onSelectionChanged = (event) => {
    setSelectedValue(event.api.getSelectedRows());
  };
  // console.log(selectedValue);
  const createArrayValues = () => {
    let formLocalBatchData = [];

    selectedValue.map((teacher) => {
      return formLocalBatchData.push({
        batch_membertable_id: teacher.batch_membertable_id,
      });
    })
    return formLocalBatchData;
  };

  var userIdAsInt = sessionStorage.getItem('user_id');
  var user_id = parseInt(userIdAsInt, 10);

  // ? API Call : Delete Method : Exclude Batch Members
  const excludeMembers = async () => {
    let mappedStatus = "";
    let excludeTeachersData = [];
       
    excludeTeachersData = createArrayValues();
    if (selectedValue.length !== 0) {
      mappedStatus = selectedValue[0].teacher_mapped_status;
    } else {
      mappedStatus = "";
    }

    try {
      if (selectedValue.length > 1 && mappedStatus === "unmapped") {
        const options = {
          method: "DELETE",
          // url: `/batchmembers/${selectedValue[0].batch_member_id}`,
          url: `/batchmembers/exclude`,
          auth: true,
          data: {
            updated_by: user_id,
            data: excludeTeachersData
          },
        };

        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data
        );
        // console.log(selectedValue);

        if (response.status === 200) {
          props.onHide();
          window.location.reload();
          dispatch(
            showSnackbar({
              message: "Teacher excluded successfully !",
              severity: "success",
            })
          );
        }
      } else if (selectedValue.length && mappedStatus === "mapped") {
        dispatch(
          showSnackbar({
            message: "Teacher is mapped to a student. Please unmap the Group.",
            severity: "error",
          })
        );
      } else if (selectedValue.length = 1 && mappedStatus === "unmapped") {
        dispatch(
          showSnackbar({
            message:
              "At least one teacher should be in the group!",
            severity: "error",
          })
        );
      }
      //  else if (selectedValue.length > 1 && mappedStatus === "mapped") {
      //   dispatch(
      //     showSnackbar({
      //       message:
      //         "Please select only one teacher to remove from the Group !",
      //       severity: "error",
      //     })
      //   );
      // } 
      else {
        dispatch(
          showSnackbar({
            message:
              "Please select atleast one teacher profile to remove from the Group !",
            severity: "error",
          })
        );
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: "Error occurred! Please try again later.",
          severity: "error",
        })
      );
    }
  };

  return (
    props.datatomodal && (
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton >
          <Modal.Title id="contained-modal-title-vcenter">
            <h4>Grouped Teachers Data</h4>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Input Box & Button */}
          <div className="d-flex justify-content-between my-2">
            <div>
              <input
                type="search"
                name="search"
                placeholder="Search Here"
                className="p-2"
                style={{
                  width: "200px",
                  padding: "10px",
                  border: "1px solid #1D3FAA",
                  borderRadius: "20px",
                  outline: "none",
                }}
                onChange={onFilterTextChange}
              />
            </div>

            <div>
              <Button type="button" variant="primary" onClick={addTeachers}>
                Add Teachers
              </Button>
            </div>
          </div>

          {/* Table */}
          <div
            className="ag-theme-alpine my-3"
            style={{ width: "100%", height: "300px" }}
          >
            <AgGridReact
              onGridReady={onGridReady}
              columnDefs={columnHeader}
              rowSelection={rowSelectionType}
              onSelectionChanged={onSelectionChanged}
              rowMultiSelectWithClick={true}
              pagination={true}
              paginationPageSize={10}
              paginationAutoPageSize={true}
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div>
            <Button type="button" variant="light" onClick={props.onHide}>
              CLOSE
            </Button>

            <Button
              type="submit"
              variant="danger"
              className="mx-3"
              onClick={excludeMembers}
            >
              EXCLUDE
            </Button>
          </div>
        </Modal.Footer>

        {/* Modal Component */}
        <UngroupedTeacher
          show={addTeacher}
          onHide={() => setAddTeacher(false)}
          getbatchid={getBatchId}
          getbatchname={getBatchName}
        // handleAttendanceModalClose={props.onCloseCallBack}
        // onCloseCallBack={handleAttendanceModalClose}
        />
      </Modal>
    )
  );
}

export default TeacherModal;
